import React from 'react';

const Footer = () => {
  return (
    <footer>
      <div className='footer-logo'>
        <img
          className='marca-correios'
          src='/images/correios horizontal.svg'
          alt='Correios'
        />
        © Copyright 2025 Correios
      </div>
    </footer>
  );
};

export default Footer;
